"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = exports.OidcManager = void 0;
const oidc_client_ts_1 = require("oidc-client-ts");
/**
 * @augments UserManager
 */
class OidcManager extends oidc_client_ts_1.UserManager {
    constructor(settings) {
        super(settings);
    }
    getClient() {
        return this._client;
    }
}
exports.OidcManager = OidcManager;
/**
 * Authenticated user information including token, id_token and claims
 * @augments OidcUser
 */
class User extends oidc_client_ts_1.User {
}
exports.User = User;
